// utils/helpers.js
import { format, isValid } from "date-fns";

export function formatDate(value) {
  if (!value) return "—";
  try {
    let d;
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
      // Parse date-only strings as LOCAL midnight to avoid UTC-shift (e.g. 20th → 19th)
      const [y, mo, dy] = value.split("-").map(Number);
      d = new Date(y, mo - 1, dy);
    } else {
      d = new Date(value);
    }
    return isValid(d) ? format(d, "dd MMM yyyy") : String(value);
  } catch { return String(value); }
}

export function formatCurrency(value, symbol = "$") {
  if (value === null || value === undefined || value === "") return "—";
  const num = parseFloat(value);
  if (isNaN(num)) return "—";
  if (num >= 1_000_000) return `${symbol}${(num / 1_000_000).toFixed(2)}M`;
  if (num >= 1_000) return `${symbol}${(num / 1_000).toFixed(1)}K`;
  return `${symbol}${num.toLocaleString("en-NG", { minimumFractionDigits: 2 })}`;
}

export function safeNum(val, fallback = 0) {
  const n = parseFloat(val);
  return isNaN(n) ? fallback : n;
}
